var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-progress-action',{attrs:{"header":_vm.headerText,"description":_vm.descriptionText},on:{"click":function($event){return _vm.doAction()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }